export function AccountIndexICS(): string {
	return `/v1/ics/me/events.ics`;
}

export function AddAttachment(organizationID: number, eventID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/attachments/${attachmentID}`;
}

export function AddCarpool(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/carpools`;
}

export function AddCarpoolPassenger(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-carpools/${ID}/passengers`;
}

export function AddCarpoolRequest(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/carpool-requests`;
}

export function AddComment(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/comments`;
}

export function AddSessionGroupUser(organizationID: number, eventID: number, sessionGroupID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups/${sessionGroupID}/users`;
}

export function AddTrainingSession(organizationID: number, eventID: number, sessionID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/sessions/${sessionID}`;
}

export function AddUsers(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/users`;
}

export function BatchRfapi(organizationID: number): string {
	return `/v1/organizations/${organizationID}/events/batch-rfapi`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/events`;
}

export function CustomizeSessionGroups(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups/customize`;
}

export function Delete(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}`;
}

export function DeleteCarpool(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-carpools/${ID}`;
}

export function DeleteCarpoolPassenger(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-carpools/${ID}/passengers`;
}

export function DeleteCarpoolRequest(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/carpool-requests`;
}

export function DeleteComment(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-comments/${ID}`;
}

export function Export(organizationID: number): string {
	return `/v1/organizations/${organizationID}/events/export`;
}

export function Game(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/game`;
}

export function GroupEventsICS(groupID: number): string {
	return `/v1/ics/groups/${groupID}/events.ics`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/events`;
}

export function IndexEventsICS(): string {
	return `/v1/ics/events.ics`;
}

export function LOKParticipants(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/lok-participants`;
}

export function ListPending(organizationID: number): string {
	return `/v1/organizations/${organizationID}/events/pending`;
}

export function RemoveAttachment(organizationID: number, eventID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/attachments/${attachmentID}`;
}

export function RemoveSessionGroupUser(organizationID: number, eventID: number, sessionGroupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups/${sessionGroupID}/users/${userID}`;
}

export function RemoveUsers(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/users`;
}

export function ResendInvites(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/users/resend-invites`;
}

export function ResetSessionGroups(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups/customize`;
}

export function Show(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}`;
}

export function ShowCarpoolRequests(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/carpool-requests`;
}

export function ShowCarpools(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/carpools`;
}

export function ShowComments(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/comments`;
}

export function ShowPracticePlan(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/practice-plan`;
}

export function ShowSessionGroups(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups`;
}

export function ShowTrainingSessions(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/sessions`;
}

export function ShowTrainingSessions1(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/training-sessions`;
}

export function ShowUsers(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/users`;
}

export function Update(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}`;
}

export function UpdateCarpool(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-carpools/${ID}`;
}

export function UpdateComment(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/event-comments/${ID}`;
}

export function UpdateSessionGroupUser(organizationID: number, eventID: number, sessionGroupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/session-groups/${sessionGroupID}/users/${userID}`;
}

export function UpdateUsers(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/users`;
}

